import { Component, Input, OnInit } from '@angular/core';
import { AJSMessagesService } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { StrategiesService } from 'src/app/shared/strategies/strategies.service';
import { Task } from 'src/app/tasks/shared/models';

@Component({
  selector: 'app-task-user',
  templateUrl: './task-user.component.html',
  styleUrls: ['./task-user.component.scss'],
})
export class TaskUserComponent implements OnInit {
  @Input() task: Task;

  displayProfileId: boolean;

  constructor(
    private ajsMessagesService: AJSMessagesService,
    private alcmeonContextService: AlcmeonContextService,
    private sitesService: SitesService,
    private strategiesService: StrategiesService
  ) {}

  ngOnInit(): void {
    const strategy = this.strategiesService.getStrategyFromType(this.task.message.from.site.type);
    this.displayProfileId = strategy.displayProfileId();
  }

  showUserInteractions() {
    const companyId = this.alcmeonContextService.companyId;
    const siteId = this.task.message.site.id;
    const userId = this.task.message.from.id;
    const avatarUrl = this.task.message.from.details.avatarUrl;
    const taskId = this.task.id;
    this.ajsMessagesService.sites = this.sitesService.sitesV2;
    this.ajsMessagesService.showUserInteractions(companyId, siteId, userId, avatarUrl, taskId, null);
  }
}
